// extracted by mini-css-extract-plugin
module.exports = {"userDataContainer":"UserData_userDataContainer__3_fE6","userName":"UserData_userName__t1Pfz","userMail":"UserData_userMail__2_bay"};